module.exports = __webpack_public_path__ + "static/media/privacypolicy_2025_03_25.96a605ea.htm";